import { Card, CardContent } from '@shared/ui';
import type React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetCalendarEventsTodayQuery } from '../../../store/api/apiSlice';
import CalendarDetail from './CalendarDetail';

const GoogleCalendarSettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading, refetch } = useGetCalendarEventsTodayQuery(undefined);
  const events = (data?.items || []) as any[];

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent sx={{ p: 2 }}>
        <CalendarDetail
          back={() => navigate('/settings/integrations')}
          iconSrc={'https://ssl.gstatic.com/calendar/images/dynamiclogo_2020q4/calendar_20_2x.png'}
          isLoading={isLoading}
          events={events as any}
          onRefresh={() => refetch()}
        />
      </CardContent>
    </Card>
  );
};

export default GoogleCalendarSettingsPage;
